const centreActivePill = (list) => {
  const active = list.querySelector('[aria-current]');
  if (!active || list.scrollWidth <= list.clientWidth) return;
  list.scrollLeft = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
};

const loadNext = async (button, moveFocus) => {
  if (button.dataset.loading) return true;
  const section = button.closest('.drv-bmain');
  const grid = section && section.querySelector('[data-drv-grid]');
  if (!grid) return false;
  const more = button.closest('.drv-bmain__more');
  const loader = more && more.querySelector('[data-drv-loading]');
  const status = more && more.querySelector('[data-drv-status]');
  button.dataset.loading = '1';
  grid.setAttribute('aria-busy', 'true');
  if (more) more.dataset.loading = '';
  if (loader) loader.hidden = false;
  if (status) status.textContent = status.dataset.loading;
  try {
    const url = new URL(button.href, window.location.origin);
    url.searchParams.set('section_id', button.dataset.section);
    const response = await fetch(url);
    if (!response.ok) throw new Error(String(response.status));
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const items = [...doc.querySelectorAll('[data-drv-grid] > li')];
    grid.append(...items);
    const next = doc.querySelector('[data-drv-more]');
    if (next) {
      button.href = next.getAttribute('href');
    } else {
      button.closest('.drv-bmain__more')?.remove();
    }
    if (moveFocus && items[0]) items[0].querySelector('a')?.focus();
    if (status) status.textContent = status.dataset.done;
    return true;
  } catch (error) {
    return false;
  } finally {
    delete button.dataset.loading;
    grid.removeAttribute('aria-busy');
    if (more) delete more.dataset.loading;
    if (loader) loader.hidden = true;
  }
};

const initMore = (button) => {
  if (button.dataset.drvMoreReady) return;
  button.dataset.drvMoreReady = '1';
  button.addEventListener('click', async (event) => {
    event.preventDefault();
    const loaded = await loadNext(button, event.detail === 0);
    if (!loaded) window.location.href = button.href;
  });
  if (!('drvAuto' in button.dataset) || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(
    async ([entry]) => {
      if (!entry.isIntersecting) return;
      const loaded = await loadNext(button, false);
      if (!loaded || !button.isConnected) {
        observer.disconnect();
        return;
      }
      observer.unobserve(button);
      observer.observe(button);
    },
    { rootMargin: '0px 0px 400px 0px' }
  );
  observer.observe(button);
};

const init = () => {
  document.querySelectorAll('[data-drv-pills]').forEach(centreActivePill);
  document.querySelectorAll('[data-drv-more]').forEach(initMore);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
document.addEventListener('shopify:section:load', init);
